export const ROUTES = {
    HOME: '/',
    IMPRINT: 'imprint',
};
